(() => {
  'use strict';
  if (window.AWReplicaModelIndex?.version) return;

  const script = document.currentScript;
  const indexUrl = String(script?.dataset?.awIndexUrl || '').trim();
  const EXPECTED_COUNT = 879;
  const SERVICE_HANDLES = {
    '12212951089416':'montage-et-reglage-optique-airsoft-red-dot-lunette-alignement-et-test',
    '12212951023880':'passage-chronographe-airsoft-mesure-fps-joules-et-fiche-de-controle',
    '12212950925576':'refection-cablage-aeg-airsoft-connecteurs-soudures-gaine-et-controle-electrique',
    '12212950892808':'entretien-chargeur-aeg-mid-cap-nettoyage-ressort-et-alimentation',
    '12212950827272':'revision-fusil-a-pompe-airsoft-a-ressort-mecanisme-alimentation-et-hop-up',
    '12212950761736':'entretien-fusil-a-pompe-airsoft-gaz-reservoir-valves-joints-et-alimentation',
    '12212950728968':'revision-nbb-co-airsoft-valves-joints-etancheite-et-hop-up',
    '12212950663432':'revision-aep-airsoft-gearbox-compacte-moteur-connectique-et-hop-up',
    '12212949614856':'preparation-replique-airsoft-neuve-controle-hop-up-chronographe-et-mise-au-point',
    '12212949582088':'controle-replique-airsoft-d-occasion-usure-fonctionnement-chronographe-et-rapport',
    '12212949549320':'revision-sniper-bolt-airsoft-cylindre-detente-hop-up-et-etancheite',
    '12212949516552':'installation-moteur-hpa-airsoft-montage-alignement-fcu-et-tests',
    '12212949483784':'entretien-hpa-airsoft-moteur-fcu-etancheite-ligne-et-reglages',
    '12212942045448':'reparation-chargeur-gaz-gbb-gbbr-valves-joints-etancheite-et-test',
    '12212941553928':'reglage-puissance-aeg-airsoft-changement-ressort-chronographe-et-validation',
    '12211017711880':'diagnostic-fuite-gaz-gbb-gbbr-chargeur-valves-joints-et-nozzle',
    '12211017646344':'revision-et-entretien-gbbr-airsoft-culasse-nozzle-valves-et-etancheite',
    '12211017580808':'reglage-et-optimisation-hop-up-airsoft-montage-alignement-et-tests',
    '12211017318664':'installation-mosfet-etu-aeg-montage-cablage-et-configuration',
    '12211017089288':'diagnostic-aeg-airsoft-panne-bruit-chauffe-ou-perte-de-puissance',
    '9610674110728':'forfait-revision-aeg',
    '9610637312264':'forfait-revision-entretien-replique-de-poing-gbb',
    '8490208755976':'forfait-montage-pieces-upgrade-replique-airsoft-1-heure',
    '8490186932488':'forfait-dentretien-repliques-airsoft-1-heure'
  };

  const normalize = (value = '') => String(value || '').trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' et ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const gidNumeric = (value = '') => String(value || '').match(/\/(\d+)$/)?.[1] || '';
  const parseRefs = (value) => {
    if (!value) return [];
    try { const parsed = JSON.parse(value); return Array.isArray(parsed) ? parsed.map(String).filter(Boolean) : []; }
    catch (_) { return []; }
  };
  const text = (field) => String(field?.value || '').trim();
  const sourceRoot = () => document.querySelector('[data-aw-tools-source],[data-aw-model-context-source]');
  const modelNodes = () => Array.from(document.querySelectorAll('[data-aw-tool-model],[data-aw-model-context-model]'));

  const refreshConsumers = (detail) => {
    const bridge = window.AWEcosystemP1Bridge;
    bridge?.injectCompatibilityModels?.();
    bridge?.renderCompatibilityCoverage?.();
    bridge?.renderContextStrip?.();
    bridge?.enhanceGarage?.();
    bridge?.enhanceAtelier?.();
    window.AWEcosystemP1Copy?.render?.();
    window.AWEcosystemP1ContextRelay?.render?.();
    window.dispatchEvent(new CustomEvent('aw:model-index-ready', { detail }));
  };

  const reconcileCanonicalContext = () => {
    if (window.AWEcosystemP1Bridge?.activeReplica?.()) return { checked:false, cleared:false, reason:'garage-active' };
    let context = null;
    try { context = window.AWAirsoftContext?.current?.() || JSON.parse(localStorage.getItem('aw_airsoft_context_v1') || '{}'); }
    catch (_) { context = null; }
    if (!context?.model && !context?.modelLabel) return { checked:false, cleared:false, reason:'no-model' };

    const modelNeedle = normalize(context.model || '');
    const labelNeedle = normalize(context.modelLabel || '');
    const manufacturerNeedle = normalize(context.manufacturerLabel || context.manufacturer || '');
    const candidates = modelNodes().filter((node) => {
      const nodeModel = normalize(node.dataset.model || '');
      const nodeLabel = normalize(node.dataset.label || '');
      if (manufacturerNeedle && normalize(node.dataset.manufacturer || '') !== manufacturerNeedle) return false;
      return Boolean((modelNeedle && nodeModel === modelNeedle) || (labelNeedle && nodeLabel === labelNeedle));
    });
    if (!candidates.length) return { checked:true, cleared:false, reason:'manual-or-unknown' };

    const platformNeedle = normalize(context.platform || '');
    const typeNeedle = normalize(context.type || context.replicaType || '');
    const compatible = candidates.some((node) => {
      if (platformNeedle && normalize(node.dataset.platform || '') !== platformNeedle) return false;
      if (typeNeedle && normalize(node.dataset.type || '') !== typeNeedle) return false;
      return true;
    });
    if (compatible) return { checked:true, cleared:false, reason:'canonical-match' };

    const detail = {
      platform:context.platform || '', platformLabel:context.platformLabel || '',
      manufacturer:context.manufacturer || '', manufacturerLabel:context.manufacturerLabel || '',
      type:context.type || context.replicaType || '', typeLabel:context.typeLabel || context.replicaTypeLabel || '',
      model:'', modelLabel:'', modelHandle:''
    };
    if (window.AWAirsoftContext?.write) window.AWAirsoftContext.write(detail, 'canonical-context-conflict-cleared');
    else {
      try {
        const stored = JSON.parse(localStorage.getItem('aw_airsoft_context_v1') || '{}');
        localStorage.setItem('aw_airsoft_context_v1', JSON.stringify({ ...stored, model:'', modelLabel:'', modelHandle:'', source:'canonical-context-conflict-cleared', updatedAt:new Date().toISOString() }));
        window.dispatchEvent(new CustomEvent('aw:context-changed', { detail }));
      } catch (_) {}
    }
    return { checked:true, cleared:true, reason:'canonical-base-conflict' };
  };

  const materialize = (records) => {
    const root = sourceRoot();
    if (!root) return { total:records.length, added:0, refreshed:0, available:false };
    const existing = new Map();
    modelNodes().forEach((node) => {
      const handle = String(node.dataset.handle || '').trim();
      if (handle && !existing.has(handle)) existing.set(handle, node);
    });
    const fragment = document.createDocumentFragment();
    let added = 0;
    let refreshed = 0;

    records.forEach((record) => {
      const handle = String(record?.handle || '').trim();
      if (!handle) return;
      let node = existing.get(handle);
      if (!node) {
        node = document.createElement('span');
        node.dataset.awToolModel = '';
        node.hidden = true;
        fragment.append(node);
        existing.set(handle, node);
        added += 1;
      } else refreshed += 1;

      node.dataset.awIndexModel = 'true';
      node.dataset.handle = handle;
      node.dataset.label = String(record?.displayName || handle).trim();
      node.dataset.model = text(record?.modelRef);
      node.dataset.manufacturer = text(record?.manufacturer);
      node.dataset.platform = String(record?.platform?.reference?.handle || '').trim();
      node.dataset.platformLabel = String(record?.platform?.reference?.displayName || '').trim();
      node.dataset.type = text(record?.replicaType);
      node.dataset.productIds = parseRefs(record?.products?.value).map(gidNumeric).filter(Boolean).join(',');
      node.dataset.workshopServices = parseRefs(record?.workshop?.value).map(gidNumeric).map((id) => SERVICE_HANDLES[id] || '').filter(Boolean).join(',');

      const pageReference = record?.page?.reference || null;
      const pageHandle = String(pageReference?.handle || '').trim();
      const pagePublished = pageReference?.isPublished === true;
      node.dataset.pageLinked = pageHandle ? 'true' : 'false';
      node.dataset.pagePublished = pagePublished ? 'true' : 'false';
      node.dataset.pageDraftUrl = pageHandle ? `/pages/${pageHandle}` : '';
      node.dataset.pageUrl = pageHandle && pagePublished ? `/pages/${pageHandle}` : '';
    });

    root.append(fragment);
    root.dataset.awModelIndex = 'bulk-admin-canonical-refresh';
    root.dataset.awModelIndexCount = String(records.length);
    document.documentElement.dataset.awModelIndexCount = String(records.length);
    return { total:records.length, added, refreshed, available:true };
  };

  const load = async () => {
    if (!indexUrl) throw new Error('AW model index URL missing');
    const response = await fetch(indexUrl, { credentials:'omit', cache:'force-cache' });
    if (!response.ok) throw new Error(`AW model index HTTP ${response.status}`);
    const raw = await response.text();
    const records = raw.split(/\r?\n/).map((line) => line.trim()).filter(Boolean).map((line) => JSON.parse(line));
    const result = materialize(records);
    const reconciliation = result.available ? reconcileCanonicalContext() : { checked:false, cleared:false, reason:'index-unavailable' };
    const state = {
      version:'1.0.3', expected:EXPECTED_COUNT, count:records.length,
      added:result.added, refreshed:result.refreshed,
      complete:records.length === EXPECTED_COUNT, available:result.available,
      reconciliation, source:'shopify-admin-bulk-jsonl-canonical-refresh'
    };
    Object.assign(window.AWReplicaModelIndex, state);
    refreshConsumers(state);
    return state;
  };

  window.AWReplicaModelIndex = {
    version:'1.0.3', expected:EXPECTED_COUNT, count:0, added:0, refreshed:0,
    complete:false, available:false, reconciliation:null,
    source:'shopify-admin-bulk-jsonl-canonical-refresh', load, reconcileCanonicalContext
  };

  load().catch((error) => {
    window.AWReplicaModelIndex.error = String(error?.message || error || 'unknown');
    window.dispatchEvent(new CustomEvent('aw:model-index-error', { detail:{ error:window.AWReplicaModelIndex.error } }));
  });
})();
